<template lang="pug">
v-main
  v-container
    v-card
      v-toolbar.elevation-0
        v-toolbar-title Create Business Unit
      v-divider
      v-card-text
        v-form.my-2
          v-row(no-gutters)
            v-col(cols="3") 
              v-subheader(color="black") Business Unit Name 
            v-col(cols="5")
              v-text-field(
                v-model="name",
                label="Name",
                @keypress="isLetter($event)",
                :rules="[rules.required]",
              )
          v-row(no-gutters)
            v-col(cols="3") 
              v-subheader(color="black") Business Unit Logo
            v-col(cols="5")
              v-file-input(
                v-model="prev_logo",
                @click="savePrevImage",
                @change="Preview_image",
                :rules="[rules.required, rules.max]",
                accept="image/png, image/jpeg, image/bmp",
                label="Upload File (Max Size: 1 MB. Format: jpg, png)."
              )
              v-img(v-if="prev_logo", :src="url_logo")

          v-row(no-gutters)
            v-col(cols="3") 
              v-subheader(color="black") Business Unit Code 
            v-col(cols="5")
              v-text-field(
                maxlength="4"
                v-model="code",
                label="Code",
                @keypress="isValidCode($event)",
                :rules="[rules.required]",
              )
            
          v-card-actions.my-8
            v-btn.custom__padding-btn(@click="$router.push('/data-bu')") Back
            v-btn.custom__padding-btn(
              :disabled="!formIsValid",
              color="blue-secondary",
              @click="create()"
            ) Create

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  data: () => ({
    name: "",
    code: "",
    prev_logo: null,
    logo: null,
    url_logo: "",
    prev_url_logo: "",
    temp_logo: "",
    rules: {
      required: (value) => !!value || "This field is required.",
      max: (value) => value.size < 1000000 ||
        "File size exceeds the limit ! (Maximum 1 MB)",
    },
    overlay: false,
  }),
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
    formIsValid() {
      return this.name && this.code;
    },
  },
  methods: {
    create() {
      this.overlay = true;
      let token = localStorage.getItem("token");
      let formData = new FormData();
      formData.append("bu_name", this.name);

      if (this.code.length == 4) formData.append("bu_code", this.code);
      else {
        this.overlay = false;
        return this.$toasted.error("Bussines Unit Code need to be 4 digits of alphanumeric.", { icon: "error" });
      }

      if (this.logo) {
        formData.append("logo", this.logo);
      } else if (this.prev_logo) {
        formData.append("logo", this.prev_logo);
      } else {
        formData.append("logo", "");
      }

      const config = {
        method: "post",
        url: process.env.VUE_APP_API + `/business-unit/create`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      };

      axios(config)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.$toasted.success("Success create data", {
              icon: "check_circle",
            });
            return this.$router.push("/data-bu");
          }
        })
        .catch((message) => {
          this.overlay = false;
          this.showError(message);
        });
    },
    showError(message) {
      this.$toasted.error(message.response.data.message, { icon: "error" });
    },
    savePrevImage() {
      // alert(this.prev_logo)
      
      if (this.prev_logo) {
        this.temp_logo = this.prev_logo
        this.prev_url_logo = this.url_logo
      }
    },
    Preview_image() {
      if (this.prev_logo) {
        this.url_logo = URL.createObjectURL(this.prev_logo);
      } else {
        this.prev_logo = this.temp_logo
        this.url_logo = this.prev_url_logo
      }
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z0-9\s.,]*$/.test(char)) return true;
      else e.preventDefault();
    },
    isValidCode(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/(^[a-zA-Z0-9\s]*)$/.test(char)) return true;
      else e.preventDefault();
    },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

div.v-input__prepend-outer {
  display: none !important;
}

div.v-image__image {
  width: 150px;
  height: 150px;
}

div.v-responsive__sizer {
  padding-bottom: 0;
}

.v-image {
  width: 150px;
  height: 150px;
}
</style>